import { render, staticRenderFns } from "./tcLayout.vue?vue&type=template&id=5f8a21e3&scoped=true&"
import script from "./tcLayout.vue?vue&type=script&lang=js&"
export * from "./tcLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a21e3",
  null
  
)

export default component.exports